/**
 * @generated SignedSource<<77fdd5f9b18c3ae6ebfd0652a80815ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ABTestPatternFilterButton_Query$variables = {};
export type ABTestPatternFilterButton_QueryVariables = ABTestPatternFilterButton_Query$variables;
export type ABTestPatternFilterButton_Query$data = {
  readonly sources: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      } | null;
    } | null> | null;
  };
};
export type ABTestPatternFilterButton_QueryResponse = ABTestPatternFilterButton_Query$data;
export type ABTestPatternFilterButton_Query = {
  variables: ABTestPatternFilterButton_QueryVariables;
  response: ABTestPatternFilterButton_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SourceConnection",
    "kind": "LinkedField",
    "name": "sources",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SourceEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Source",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ABTestPatternFilterButton_Query",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ABTestPatternFilterButton_Query",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "8c2edcad3faef32265b3fe8526eb01f8",
    "id": null,
    "metadata": {},
    "name": "ABTestPatternFilterButton_Query",
    "operationKind": "query",
    "text": "query ABTestPatternFilterButton_Query {\n  sources {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5cd20353f16d228eba78eed3e9537398";

export default node;
